const messages = {
  "ui.colorComponents.changeColor": "Change Color",
} as const;

export default messages;
